<template>
  <div class="home">
    <div class="filter-wrapper filter-wrapper-tab">
      <CallsLink />
      <div class="link-filter-wrapper">
        <div>
          <call-input
            v-model.trim="dataSearch"
            class="link-filter-wrapper__search"
            type-input="search"
            :enter-icon="true"
            placeholder="Search Name & Project"
            @input="onSearchClear($event, 'dataSearch')"
            @enter="onSearch">
            <template slot="prefix">
              <font-awesome-icon :icon="dataIconSearch" />
            </template>
          </call-input>
          <CallCheckedClosedOpenedCustom
            v-model="dataFilterActiveArchived"
            :config-tab="configTab" />
          <v-select
            v-model="dataSelectProject"
            :options="computedProjectList"
            :filterable="true"
            :searchable="true"
            label="name"
            :components="{ Deselect: dataComponentDeselect }"
            placeholder="All Projects"
            striped
            :class="[
              'call-select call-select-filter teams-filter',
              dataSelectProject ? 'call-select--value' : null
            ]"
            @input="onSelectTeams">
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes">
                <font-awesome-icon :icon="dataIconDown" />
              </span>
            </template>
            <template
              slot="option"
              slot-scope="option">
              <div class="d-center">
                <font-awesome-icon
                  v-if="!option.is_active"
                  class="tabel-icon--red"
                  style="font-size: 10px;"
                  :icon="dataIconLock" />
                {{ option.name }}
              </div>
            </template>
          </v-select>

          <v-select
            v-model="dataSelectTeamsValue"
            :options="dataSelectOptionsTeam"
            label="name"
            :components="{ Deselect: dataComponentDeselect }"
            placeholder="All Teams"
            :class="[
              'call-select call-select-filter teams-filter',
              dataSelectTeamsValue ? 'call-select--value' : null
            ]"
            @input="onSelectTeams">
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes">
                <font-awesome-icon :icon="dataIconDown" />
              </span>
            </template>
            <template slot="no-options">
              Name Team
            </template>
            <template
              slot="option"
              slot-scope="option">
              <div class="d-center">
                <font-awesome-icon
                  v-if="!option.is_active"
                  class="tabel-icon--red"
                  style="font-size: 10px;"
                  :icon="dataIconLock" />
                {{ option.name }}
              </div>
            </template>
          </v-select>

          <popover
            v-model="dataShowPopover"
            trigger="click">
            <div style="padding: 6px">
              <span class="filter-wrapper__label">Type Auto-Call</span>
              <CallAutoType2 v-model="dataFilterTypeAutoCall" />
              <span class="filter-wrapper__label">Status Auto-Call</span>
              <CallAutoStatus2 v-model="dataFilterStatusAutoCall" />
              <div style="display: flex; min-width: 300px; margin-top: 6px">
                <call-button
                  type="danger"
                  plain
                  full
                  style="margin: 0px 2px"
                  :icon="dataIconClose"
                  @click="clickFilterCancel()">
                  &nbsp;Clear Filter
                </call-button>
                <call-button
                  type="success"
                  full
                  style="margin: 0px 2px"
                  :icon="dataIconCheck"
                  @click="clickFilterSend()">
                  &nbsp;Filter
                </call-button>
              </div>
            </div>
            <template #reference>
              <call-button
                :icon="dataIconFilter"
                style="position: relative">
                Filter
                <call-badge
                  v-if="computedFilterCount > 0"
                  class="call-filter-badge"
                  type="danger">
                  {{ computedFilterCount }}
                </call-badge>
              </call-button>
            </template>
          </popover>
        </div>
        <div>
          <call-pagination
            page-calc
            :page-value="50"
            :obj-pagination="dataObjPagination"
            @on-pagination="$_ajax" />
        </div>
      </div>
    </div>
    <div class="table-wrapper table-wrapper-autocall">
      <b-table
        :show-empty="isLoaded"
        striped
        hover
        no-local-sorting
        :fields="dataMixinAutoCallFields"
        :items="dataAutoCall"
        sort-by="created_at"
        :sort-desc="true"
        @sort-changed="onSortTabel"
        @row-hovered="onHover"
        @row-unhovered="onUnHover">
        <template #empty>
          <EmptyTable />
        </template>
        <template #cell(created_at)="data">
          {{ data.item.created_at | dateFilter }}
        </template>
        <template #cell(updated_at)="data">
          {{ data.item.updated_at | dateFilter }}
        </template>
        <template #cell(status)="data">
          <span :class="`table-status-${data.item.status}`">
            {{ data.item.status }}
          </span>
        </template>
        <template #cell(type)="data">
          <span :class="`table-type-${data.item.type}`">
            {{ data.item.type }}
          </span>
        </template>
        <template #cell(days)="data">
          {{ data.item.settings.days.join(', ') }}
        </template>
        <template #cell(time)="data">
          {{ data.item.settings.period_start.slice(0, 5) }}
          - {{ data.item.settings.period_end.slice(0, 5) }}
        </template>
        <template #cell(settings.tasks_count)="data">
          {{ data.item.settings.tasks_all
            ? 'All'
            : (data.item.type === 'custom'
              ? `Custom ${data.item.settings.tasks_count}`
              : `${data.item.settings.tasks_count}`)
          }}
        </template>
        <template #cell(actions)="data">
          <CallTableSettingsActions
            :data="{item: data.item, permissions: dataObjPermissions[data.item.id]}"
            :disabled="false"
            :blocked="((computedIsAdmin || computedIsModerator))"
            @on-action="(value) => onActions(data.item, value)" />
        </template>
      </b-table>
    </div>

    <CallUpdateProjectTimeSettings
      v-model="dataShowProjectSetting"
      :project-id="projectId"
      :project-data="projectData"
      @on-update="onSelectRefresh" />

    <CallModal
      v-model="isOpenModal"
      :data="dataModal"
      use-view="AutoCalls"
      @input="handlerModal" />
  </div>
</template>

<script>
import CallAutoStatus2 from '@/components/common/CallAutoStatus2.vue';
import CallAutoType2 from '@/components/common/CallAutoType2.vue';

import CallTableSettingsActions from '@/components/desktop/CallTableSettingsActions';
import CallsLink from './components/CallsLink.vue';
import CallModal from '@/components/common/modals/CallModal.vue';
import { BTable } from 'bootstrap-vue';
import {
  AUTOCALL_GET,
  TEAMS_GET_ALL,
  PROJECTS_GET_ALL,
  AUTOCALL_UPDATE_RUN_STATUS,
  AUTOCALL_RUN_ARCHIVE
} from '../../../store/types/actions.types';
import helper from '../../../service/helper';
import CallPagination from '@/components/desktop/CallPagination';
import {
  faCheck,
  faClock,
  faFilter,
  faSearch,
  faTimes,
  faPowerOff
} from '@fortawesome/pro-regular-svg-icons';
import CallUpdateProjectTimeSettings from '@/components/common/modals/CallUpdateProjectTimeSettings';
import selectAllTeams from '../../../mixins/select/selectAllTeams';
import { mapGetters } from 'vuex';
import selectOperators from '../../../mixins/select/selectOperators';
import selectReportPeriod from '../../../mixins/select/selectReportPeriod';
import CallButton from '../../../components/common/CallButton';
import Popover from 'vant/lib/popover';
import 'vant/lib/popover/style';
import CallBadge from '@/components/common/CallBadge';
import autoCallProjectTable from '../../../mixins/table/autoCallProjectTable';
import CallInput from '../../../components/common/CallInput';
import CallCheckedClosedOpenedCustom from '@/components/common/CallCheckedClosedOpenedCustom';

export default {
  name: 'AutoCalls',
  components: {
    CallTableSettingsActions,
    CallPagination,
    BTable,
    Popover,
    CallBadge,
    CallButton,
    CallInput,
    CallsLink,
    CallUpdateProjectTimeSettings,
    CallAutoStatus2,
    CallAutoType2,
    CallModal,
    CallCheckedClosedOpenedCustom
  },
  mixins: [autoCallProjectTable, selectAllTeams, selectOperators, selectReportPeriod],
  data () {
    const filter = {
      dataIconLock: faPowerOff,
      dataIconFilter: faFilter,
      dataIconClose: faTimes,
      dataIconSearch: faSearch,
      dataShowPopover: false,
      dataSelectOptionsTeam: [],
      dataSelectProject: null,
      dataProjectList: [],
      filterPhone: [
        {
          active: false,
          name: 'Successful',
          key: 'success'
        },
        {
          active: false,
          name: 'Cancelled',
          key: 'cancelled'
        },
        {
          active: false,
          name: 'No Answer',
          key: 'noanswer'
        },
        {
          active: false,
          name: 'Rejected',
          key: 'rejected'
        },
        {
          active: false,
          name: 'Invalid Number',
          key: 'invalid_number'
        },
        {
          active: false,
          name: 'Not Available',
          key: 'not_available'
        }
      ]
    };
    const issues = {
      dataSelectIssueValue: null,
      dataSelectOptionsIssues: []
    };

    return {
      dataFilterActiveArchived: 'active',
      dataModal: null,
      isOpenModal: false,
      isLoaded: false,
      dataFilterTypeAutoCall: null,
      dataFilterStatusAutoCall: null,
      dataShowProjectSetting: false,
      projectId: 1,
      projectData: {},
      dataIconCheck: faCheck,
      dataIconError: faTimes,
      dataIconClock: faClock,
      dataObjPagination: {},
      dataObjPermissions: {},
      dataAutoCall: [],
      dataDesc: true,
      dataOrderBy: 'created_at',
      dataSearch: null,
      configTab: [
        {
          name: 'Active',
          action: 'active'
        },
        {
          name: 'Archived',
          action: 'archive'
        }
      ],
      ...filter,
      ...issues
    };
  },

  computed: {
    ...mapGetters({
      computedIsOperator: 'auth/isOperator',
      computedIsModerator: 'auth/isModerator',
      computedCurrentUser: 'auth/currentUser',
      computedIsAdmin: 'auth/isAdmin'
    }),

    computedDataFilterIsActive () {
      if (this.dataFilterActiveArchived === 'active') {
        return false;
      }
      if (this.dataFilterActiveArchived === 'archive') {
        return true;
      }
      return undefined;
    },

    computedProjectList () {
      return this.dataProjectList
        .map(({ id, name, is_active }) => {
          return { id, name, is_active };
        })
        .sort((a, b) => b.is_active - a.is_active);
    },
    computedFilterCount () {
      const typeAutoCall = this.dataFilterTypeAutoCall ? 1 : 0;
      const statusAutoCall = this.dataFilterStatusAutoCall ? 1 : 0;

      return 0 + typeAutoCall + statusAutoCall;
    }
  },

  watch: {
    dataFilterActiveArchived (v) {
      this.$_ajax({ reset: true });
    }
  },

  async created () {
    this.$_ajax = ((options = {}) => {
      this.isLoaded = false;
      let _page = 0;
      let _limit = 50;

      const { currentRoute: { name: pageName } = {} } = this.$router;

      const _filterKey = `_filter${pageName}`;

      if (!helper.isEmpty(this.$route.query, _filterKey)) {
        try {
          options = helper.clearObject(
            JSON.parse(this.$route.query[_filterKey])
          );

          const _arrFilter = [
            'desc',
            'orderBy',
            'limit',
            'page',
            'period',
            'team_ids',
            'project_ids',
            'operator_ids',
            'limit',
            'page',
            'search',
            'statuses',
            'issue_id',
            'type',
            'status',
            'is_archived'
          ];

          for (const _key of _arrFilter) {
            if (!helper.isEmpty(options, _key)) {
              switch (_key) {
                case 'type':
                  this.dataFilterTypeAutoCall = options[_key];
                  break;
                case 'status':
                  this.dataFilterStatusAutoCall = options[_key];
                  break;
                case 'period':
                  this.dataSelectLastDayValue = options[_key];
                  break;
                case 'search':
                  this.dataSearch = options[_key];
                  break;
                case 'desc':
                  this.dataDesc = options[_key];
                  break;
                case 'orderBy':
                  this.dataOrderBy = options[_key];
                  break;
                case 'team_ids':
                  this.dataSelectTeamsValue = options[_key];
                  break;
                case 'project_ids':
                  this.dataSelectProject = options[_key];
                  break;
                case 'issue_id':
                  this.dataSelectIssueValue = options[_key];
                  break;
                case 'operator_ids':
                  this.dataSelectOperatorValue = options[_key];
                  break;
                case 'limit':
                  _limit = options[_key];
                  break;
                case 'page':
                  _page = options[_key];
                  break;
                case 'statuses':
                  this.filterPhone = options[_key];
                  break;
                case 'is_archived':
                  this.dataFilterActiveArchived = options[_key];
                  break;
              }
            }
          }
        } catch (e) {
          console.log('Error query params');
        }
      }

      return async ({
        desc = this.dataDesc,
        orderBy = this.dataOrderBy,
        teamId = this.dataSelectTeamsValue,
        projectId = this.dataSelectProject,
        issuesId = this.dataSelectIssueValue,
        limit = null,
        page = null,
        reset = false,
        search = this.dataSearch,
        is_archived = this.dataFilterActiveArchived
      } = options) => {
        this.$store.dispatch('loading/startLoading');

        try {
          if (!this.dataSelectLastDayValue) {
            this.dataSelectLastDayValue = {
              ...this.dataSelectLastDayValueDefault
            };
          }

          if (!helper.isEmpty(page) && page !== _page) {
            _page = page;
          }

          if (!helper.isEmpty(limit) && limit !== _limit) {
            _limit = limit;
          }

          if (reset) {
            _page = 0;
          }

          const { payload = [], misc: { paging = {}, permissions = {} } = {} } = await this.$store.dispatch(
              `autocall/${AUTOCALL_GET}`,
              helper.clearObject({
                params: {
                  desc,
                  order_by: orderBy,
                  limit: _limit,
                  page: _page,
                  team_ids: helper.clearObject([teamId?.id]),
                  project_ids: helper.clearObject([projectId?.id]),
                  search,
                  status: this.dataFilterStatusAutoCall,
                  type: this.dataFilterTypeAutoCall,
                  is_archived: this.computedDataFilterIsActive
                }
              })
          );

          this.dataObjPermissions = permissions;
          this.dataObjPagination = paging;
          this.dataAutoCall = payload.map(item => {
            item.actions = false;
            return item;
          });

          this.$router
            .replace({
              ...this.$router.currentRoute,
              query: {
                [_filterKey]: JSON.stringify(
                  helper.clearObject({
                    desc,
                    search,
                    period: this.dataSelectLastDayValue,
                    orderBy,
                    team_ids: teamId,
                    project_ids: projectId,
                    issue_id: issuesId,
                    limit: _limit,
                    page: _page,
                    operator_ids: this.computedIsOperator
                      ? [this.computedCurrentUser]
                      : this.dataSelectOperatorValue,
                    statuses: this.filterPhone,
                    status: this.dataFilterStatusAutoCall,
                    type: this.dataFilterTypeAutoCall,
                    is_archived: this.dataFilterActiveArchived
                  })
                )
              }
            })
            .catch(() => {});

          options = {};
          this.isLoaded = true;
        } finally {
          this.$store.dispatch('loading/stopLoading');
        }
      };
    })();

    this.$store.dispatch('loading/startLoading');

    try {
      const [
        {
          payload: { list: listTeam = [] }
        }
      ] = await Promise.all([
        this.$store.dispatch(`team/${TEAMS_GET_ALL}`, {
          params: {
            short: true,
            has_auto_call: true
          }
        }),
        // this.$_ajaxUserAll(),
        this.$_ajax(),
        this.getProjects()
        // this.$_ajaxIssues()
      ]);

      this.dataSelectOptionsTeam = listTeam.sort(
        (a, b) => b.is_active - a.is_active
      );
    } finally {
      this.$store.dispatch('loading/stopLoading');
    }
  },

  methods: {
    handlerModal (action) {
      if (action === 'cancel') {
        this.isOpenModal = false;
        this.dataModal = null;
      }
      if (action === 'confirm') {
        const { id, action: actionApi } = this.dataModal;
        this.updateAutoCallStatus(id, actionApi);
        this.isOpenModal = false;
        this.dataModal = null;
      }
      if (action === 'archive') {
        const { id } = this.dataModal;
        this.archiveAutoCallRun(id);
        this.isOpenModal = false;
        this.dataModal = null;
      }
    },

    onSearchClear (e, flag) {
      const { currentRoute: { name: pageName } = {} } = this.$router;
      const _filterKey = `_filter${pageName}`;

      const { search = '' } = JSON.parse(
        this.$route.query[_filterKey]
      );
      if (
        (flag === 'dataSearch' && search && !this.dataSearch)
      ) {
        this.$_ajax({ reset: true });
      }
    },

    async  onActions (data, action) {
      const { id, name } = data;

      switch (action) {
        case 'edit':
          this.projectId = data.project_id;
          this.projectData = data;
          this.dataShowProjectSetting = true;
          break;

        case 'view':
          this.$router.push({
            name: 'AutoCallsDetail',
            params: {
              id
            },
            query: {
              ...this.$route.query,
              id,
              name
            }
          });
          break;

        case 'play':
          this.updateAutoCallStatus(id, 'resume');
          break;

        case 'pause':
          this.updateAutoCallStatus(id, 'pause');
          break;

        case 'stop':
          this.isOpenModal = true;
          this.dataModal = { id, action: 'stop', ...data };
          break;

        case 'archive':
          this.isOpenModal = true;
          this.dataModal = { id, action: 'archive', ...data };
          break;
      }
    },

    async archiveAutoCallRun (id) {
      try {
        await this.$store.dispatch(`autocall/${AUTOCALL_RUN_ARCHIVE}`, {
          id,
          params: helper.clearObject({})
        });
        this.$_ajax({ reset: true });
      } catch (error) {
        console.log(error);
      }
    },

    async updateAutoCallStatus (id, action) {
      try {
        await this.$store.dispatch(`autocall/${AUTOCALL_UPDATE_RUN_STATUS}`, {
          id,
          params: helper.clearObject({
            action
          })
        });
        this.$_ajax({ reset: true });
      } catch (error) {
        console.log(error);
      }
    },

    async getProjects () {
      try {
        const {
          payload: { list = [] },
          misc: { paging = {} }
        } = await this.$store.dispatch(`project/${PROJECTS_GET_ALL}`, {
          params: helper.clearObject({

          })
        });

        this.dataProjectList = list.map(item => {
          item.actions = false;
          return item;
        }).filter((item) => item.auto_calls_available);
      } catch (error) {
        console.log(error);
      }
    },

    onSearch () {
      this.$_ajax({ reset: true });
    },

    clickFilterSend () {
      this.dataShowPopover = false;
      this.$_ajax({ reset: false });
    },
    clickFilterCancel () {
      this.dataFilterTypeAutoCall = null;
      this.dataFilterStatusAutoCall = null;
      this.dataShowPopover = false;
      this.$_ajax({ reset: true });
    },
    onSelectRefresh () {
      this.$_ajax({ reset: true });
    },
    onSelectTeams () {
      this.dataSelectOperatorValue = null;
      this.dataSelectIssueValue = null;
      // this.$_ajaxIssues(this.dataSelectTeamsValue?.id);
      this.$_ajax({ reset: true });
    },
    methodTypeCall (value = '') {
      const [hour = 0, minutes = 0, seconds = 0] = value?.split(':') ?? [];
      const allDuration = +seconds + minutes * 1 * 60 + 1 * hour * 3600;

      if (allDuration === 0) {
        return 'danger';
      } else if (allDuration > 1 && allDuration < 20) {
        return 'warning';
      }
      return 'success';
    },
    onSortTabel ({ sortBy, sortDesc }) {
      this.dataDesc = sortDesc;
      this.dataOrderBy = sortBy;
      this.$_ajax();
    }
  }
};
</script>

<style lang="scss">
.table-status-running {
  color: #e96c2c;
  text-transform: capitalize;
}
.table-status-complete {
  color: #20a052;
  text-transform: capitalize;
}
.table-status-stopped {
  color: #dd2f43;
  text-transform: capitalize;
}
.table-type-auto {
  text-transform: capitalize;
}
.table-type-custom, .table-status-paused{
  color: #e96c2c;
  text-transform: capitalize;
}

.call-td--no-wrap {
  white-space: nowrap;
}

.table-wrapper-autocall {
  .call-tabel-action {
    width: 120px;
  }
  .table_actions {
    text-align: center;
  }
}

.link-filter-wrapper__search {
  width: 220px;
}

</style>
